export default __webpack_public_path__ + "static/media/webcam.02f822cf.svg";